import { ArticleEstimation } from '../../domain/estimations/Estimations';

export interface EstimationDetails {
    pcs: number;
    totalPrice: number;
}

export default (estimations?: ArticleEstimation[]): EstimationDetails => {
    const blankEstimationDetails = { pcs: 0, totalPrice: 0 };
    if (!estimations) {
        return blankEstimationDetails;
    }
    let estimationValue: number = 0;
    let pcsCount: number = 0;

    for (const estimation of estimations) {
        estimation.itemsEstimations.forEach(itemEstimation => {
            pcsCount += itemEstimation.value;
            estimationValue += estimation.discountedPrice * itemEstimation.value;
        });
    }

    estimationValue = Math.round(estimationValue * 100) / 100;
    return { pcs: pcsCount, totalPrice: estimationValue };
};



// WEBPACK FOOTER //
// ./src/application/estimations/getEstimationsDetails.ts